const f=async(e,n,i)=>{let t;return e.element?t=e.element:e.factory?t=await e.factory():e.htmlTag&&(e.htmlUrl&&await import(e.htmlUrl),t=window.document.createElement(e.htmlTag)),t.view=e,t.region=n,t.viewKey=i,t};export{f as viewFactory};
